import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  // 定义状态
  state: {
    langues:'zh',
    lang: 'en'
  },
  mutations:{
  	newTitle(state,msg){
      state.langues=msg
    },
    changLang(state,lang) {
      state.lang = lang
      localStorage.setItem('lang', lang)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js